import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StepAction } from '@telespot/domain';

export type CloudSubject = StepAction.SAMPLE_CREATED | StepAction.ASSET_CREATED;

@Component({
  selector: 'ts-cloud-subject-selector',
  templateUrl: './cloud-subject-selector.component.html',
  styleUrls: ['./cloud-subject-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class CloudSubjectSelectorComponent {
  @Input() value: CloudSubject | null = null;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<CloudSubject>();

  public readonly SAMPLE = StepAction.SAMPLE_CREATED;
  public readonly ASSET = StepAction.ASSET_CREATED;

  onChange(event: Event): void {
    const next = (event.target as HTMLSelectElement).value as CloudSubject;
    this.valueChange.emit(next);
  }
}
